import React from 'react';
import { Route, Switch } from 'react-router-dom';
import './App.css';
import 'orbiter-web-components/src/bootstrap.css';
const App = (a) => {
    return (React.createElement(Switch, null, a.routes.map((route, index) => {
        return (React.createElement(Route, { key: index, path: route.path, exact: route.exact, render: (props) => React.createElement(route.component, Object.assign(Object.assign({}, props), { sd: {
                    parentLoader: {
                        key: 'root' + index,
                        keyPath: 'root' + index,
                    },
                    serverLoadedData: a.serverLoadedData,
                }, sdKey: 'root' })) }));
    })));
};
export default App;
//# sourceMappingURL=App.js.map